<template>
  <div
    v-for="(item, index) in data"
    :key="index"
    :class="{
      'w-full md:w-1/3': true,
    }"
  >
    <div
      :class="{
        'error-box flex h-full flex-col lg:rounded-tl-md lg:rounded-tr-md lg:border lg:border-[#dcdfeb] lg:bg-[rgba(220,223,235,0.2)]': true,
      }"
    >
      <div
        :class="{
          'box-header flex-grow px-1 py-6 lg:text-center': true,
        }"
      >
        <component
          :is="getComponent(item.cardHeader._type)"
          :value="item.cardHeader"
        />
      </div>
      <div class="box-body">
        <ImageAtom
          v-if="item.image"
          v-bind="item.image"
          loading="eager"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import ImageAtom from '~/components/Atoms/ImageAtom/ImageAtom.vue';
import { getComponent } from '~/components/Mapper';
import type { UssErrorCard } from '~/sanity/types';
defineProps<{ data: UssErrorCard }>();
</script>

<style>
.error-box .box-body .container {
  padding: 0 !important;
}
</style>
